import { FC, useCallback, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { StatsCard } from "../../../components/card/StatsCard";
import { HomeTab } from "../../../factories/works/models/home-enums";
import { WorkTableSort } from "../../works/types/work-table";

type Props = {
  thisWeek: number;
  nextWeek: number;
  later: number;
  allOpen: number;
  completed: number;
  isLoading?: boolean;
  isError?: boolean;
};

export const HomeStats: FC<Props> = ({
  thisWeek,
  nextWeek,
  later,
  allOpen,
  completed,
  isLoading = false,
  isError = false,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const activeTab = searchParams.get("home-tab") as HomeTab;

  const handleChangeTab = useCallback(
    (tab: HomeTab) => {
      setSearchParams({
        "home-tab": tab,
        page: "1",
        sortBy: WorkTableSort.StartDate,
        sortOrder: "desc",
      });
    },
    [setSearchParams],
  );

  useEffect(() => {
    if (!activeTab) {
      handleChangeTab(HomeTab.ThisWeek);
    }
  }, [activeTab, handleChangeTab]);

  return (
    <div className={"grid grid-cols-5 gap-6"}>
      <button type={"button"} onClick={() => handleChangeTab(HomeTab.ThisWeek)}>
        <StatsCard
          cardName={"This week"}
          cardCounts={thisWeek}
          isActive={activeTab === HomeTab.ThisWeek}
          isLoading={isLoading}
          isError={isError}
        />
      </button>

      <button type={"button"} onClick={() => handleChangeTab(HomeTab.NextWeek)}>
        <StatsCard
          cardName={"Next week"}
          cardCounts={nextWeek}
          isActive={activeTab === HomeTab.NextWeek}
          isLoading={isLoading}
          isError={isError}
        />
      </button>

      <button type={"button"} onClick={() => handleChangeTab(HomeTab.DueLater)}>
        <StatsCard
          cardName={"Later"}
          cardCounts={later}
          isActive={activeTab === HomeTab.DueLater}
          isLoading={isLoading}
          isError={isError}
        />
      </button>

      <button type={"button"} onClick={() => handleChangeTab(HomeTab.AllOpen)}>
        <StatsCard
          cardName={"All open"}
          cardCounts={allOpen}
          isActive={activeTab === HomeTab.AllOpen}
          isLoading={isLoading}
          isError={isError}
        />
      </button>

      <button
        type={"button"}
        onClick={() => handleChangeTab(HomeTab.Completed)}>
        <StatsCard
          cardName={"Completed"}
          cardCounts={completed}
          isActive={activeTab === HomeTab.Completed}
          isLoading={isLoading}
          isError={isError}
        />
      </button>
    </div>
  );
};
